import { atom } from 'jotai';

import { appStore } from '@/atoms/store';

export const fairUsageModalOpenAtom = atom(false);

export const openFairUsageModal = () => {
  appStore.set(fairUsageModalOpenAtom, true);
};
